import React, { useEffect } from "react";
import Logo from "../assets/images/Logo.png";
import ProfileIcons from "../domains/ProfileIcons";
import { toGetDashboard } from "../apis/actions/dashboard.actions";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../apis/store";
import { useNavigate } from "react-router-dom";

const Navbar = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  useEffect(() => {
    dispatch(toGetDashboard());
  }, [dispatch]);
  const { dashboardData } = useSelector((state: RootState) => state?.dashboard);

  const today = new Date();
  const todayGregorianDate = `${today.getFullYear()}/${String(
    today.getMonth() + 1,
  ).padStart(2, "0")}/${String(today.getDate()).padStart(2, "0")}`;

  return (
    <nav className="navbar" dir="rtl">
      <div
        className="navbar-logo"
        onClick={() => {
          navigate("/");
        }}
        style={{ cursor: "pointer" }}
      >
        <img src={Logo} alt="Logo" />
      </div>
      <div className="navbar-title-wrapper">
        <div className="navbar-title">لوحة المؤشرات</div>
      </div>
      <div className="navbar-right">
        <div className="navbar-date">
          {dashboardData?.list?.today_hijri_date} | {todayGregorianDate}
        </div>
        <div className="navbar-user-name">
          {dashboardData?.list?.user_name}
        </div>
        <ProfileIcons />
      </div>
    </nav>
  );
};

export default Navbar;
